/* eslint-disable no-undef */

// Two environments only. `isDev` is decided at bundle build time
// (esbuild define NODE_ENV): `yarn dev` / bin/dev build development,
// the Docker image builds production.
export const isDev = process.env.NODE_ENV === 'development'
export const isProd = !isDev

// Stripe publishable key: injected by the gwmc layout at runtime
// (window.__STRIPE_PK = AppSecrets.stripe_public_key) so the browser always
// uses the key that pairs with the server's secret key — live on prod, test
// keys in dev/e2e. The literals below are only a fallback.
const runtimeStripeKey = typeof window !== 'undefined' && window.__STRIPE_PK ? window.__STRIPE_PK : null

// PRODUCTION
const productionSettings = {
  host: '',
  googleAppId: '1098937269642-sqria3isol9mcacbasbnpn5fegnfrvtu.apps.googleusercontent.com',
  stripeApiKey: runtimeStripeKey || 'pk_live_514fBWQFgGdBCHsiDinAHj5xKc2r3SAonvLeDL1XqiOfIMchqC2csas2s8LGVLOU3OUie8yh27ZYQkWV5yZkMiRpO003LsqywQD',
  googleAnalyticsMeasurementId: 'G-49XN9KMW9V'
}

// DEVELOPMENT (bin/dev, Playwright): test-mode Stripe.
const developmentSettings = {
  host: '',
  googleAppId: '1098937269642-sqria3isol9mcacbasbnpn5fegnfrvtu.apps.googleusercontent.com',
  stripeApiKey: runtimeStripeKey || 'pk_test_8gk8C4ivJ9V87QwYbGu8gP7E',
  googleAnalyticsMeasurementId: 'G-49XN9KMW9V'
}

// Local dev should never hit live Stripe - the server-side STRIPE_SECRET_KEY
// in the dev container is a test key, and pairing it with a live publishable
// key on the client produces "sessionId is for a test mode Checkout Session,
// whereas Stripe.js was initialized with a live mode publishable key".
export const settings = isDev ? developmentSettings : productionSettings;
